import "./HomePage.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import {    Button,    Card,    CardBody,    Col,    Container,    Row,} from "reactstrap";
import {    FiBriefcase,} from "react-icons/fi";
import {    useEffect,    useState,} from "react";
import CourseComponents from "../../components/HomeComp/CourseComponents";
import CourseEnquiryModal from "../../components/common/Contact/CourseEnquiryModal";
import PlacementPopup from "./PlacementPopup";


const HomePage = () => {

    const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);   

    const [isPlacementOpen, setIsPlacementOpen] = useState(false);


    /*
     * POPUP OPEN DELAY
     
     *
     * 1000 = 1 second
     * 1500 = 1.5 seconds
     * 2000 = 2 seconds
     */

    const PLACEMENT_POPUP_DELAY = 2000;

    /*
     * OPEN PLACEMENT POPUP AFTER DELAY
     */

    useEffect(() => {

        const timer = setTimeout(() => {

            setIsPlacementOpen(true);

        }, PLACEMENT_POPUP_DELAY);


        return () => {

            clearTimeout(timer);

        };

    }, []);


    const toggleEnquiry = () => {

        setIsEnquiryOpen((prev) => !prev);

    };


    return (

        <main className="homepage">


            <PlacementPopup
                isOpen={isPlacementOpen}
                toggle={() => setIsPlacementOpen(false)}
            />


            {/* =================================================
                HERO SECTION
            ================================================= */}

            <section className="hero-section">


                <div className="hero-glow hero-glow-1"></div>

                <div className="hero-glow hero-glow-2"></div>

                <div className="hero-grid-pattern"></div>


                <Container className="hero-container">

                    <div className="hero-main-content">


                        {/* =================================================
                            LOGO
                        ================================================= */}

                        <div className="hero-logo-box">

                            <img
                                src="/image.png"
                                alt="FeesWorth Online Training"
                            />

                        </div>


                        {/* =================================================
                            BRAND
                        ================================================= */}

                        <div className="hero-brand">

                            <div className="hero-eyebrow">

                                FEESWORTH

                                <span className="hero-eyebrow-dot"></span>

                                LIVE & INTERACTIVE

                                <span className="hero-eyebrow-dot"></span>

                                ONLINE TRAINING

                            </div>


                            <h2>
                                Learn from Experts Working at Top Tech Companies
                            </h2>


                            <p className="fs-4">
                                Work with Real Engineers on Real Engineering Projects
                            </p>

                        </div>


                        {/* =================================================
                            BENEFITS
                        ================================================= */}

                        <div className="hero-benefits-wrapper">

                            <Row className="g-3">


                                {/* -------------------------------------------------
                                    BENEFIT 01
                                ------------------------------------------------- */}

                                <Col
                                    xs="12"
                                    sm="6"
                                    lg="4"
                                >

                                    <Card className="hero-benefit-card">

                                        <CardBody>

                                            <div className="hero-benefit-icon free-class-icon">

                                                <CheckCircleIcon />

                                            </div>


                                            <span className="hero-benefit-number">
                                                01
                                            </span>


                                            <h3>
                                                Start with Free Classes
                                            </h3>


                                            <p>
                                                Experience our live training, teaching style,
                                                and learning approach before you decide to enroll.
                                            </p>

                                        </CardBody>

                                    </Card>

                                </Col>


                                {/* -------------------------------------------------
                                    BENEFIT 02
                                ------------------------------------------------- */}

                                <Col
                                    xs="12"
                                    sm="6"
                                    lg="4"
                                >

                                    <Card className="hero-benefit-card">

                                        <CardBody>

                                            <div className="hero-benefit-icon installment-icon">

                                                <AccountTreeIcon />

                                            </div>


                                            <span className="hero-benefit-number">
                                                02
                                            </span>


                                            <h3>
                                                Pay in Easy Installments
                                            </h3>


                                            <p>
                                                Learn without financial pressure with flexible
                                                installment plans designed to make your training
                                                more affordable.
                                            </p>

                                        </CardBody>

                                    </Card>

                                </Col>


                                {/* -------------------------------------------------
                                    BENEFIT 03
                                ------------------------------------------------- */}

                                <Col
                                    xs="12"
                                    sm="6"
                                    lg="4"
                                >

                                    <Card className="hero-benefit-card">

                                        <CardBody>

                                            <div className="hero-benefit-icon">

                                                <FiBriefcase />

                                            </div>


                                            <span className="hero-benefit-number">
                                                03
                                            </span>


                                            <h3>
                                                Pay Only If You're Satisfied
                                            </h3>


                                            <p>
                                                Start learning with confidence and pay only
                                                after you are satisfied with our Demo classes
                                                and sample videos.
                                            </p>

                                        </CardBody>

                                    </Card>

                                </Col>


                            </Row>

                        </div>


                        {/* =================================================
                            CTA
                        ================================================= */}

                        <div className="hero-cta mt-5">

                            <Button
                                color="primary"
                                className="fs-5"
                                onClick={toggleEnquiry}
                            >
                                Start with free Classes
                            </Button>


                            <CourseEnquiryModal
                                isOpen={isEnquiryOpen}
                                toggle={toggleEnquiry}
                                courseName={"Feesworth"}
                            />

                        </div>


                    </div>

                </Container>

            </section>


            {/* =================================================
                COURSES
            ================================================= */}

            <CourseComponents />


        </main>
    );
};


export default HomePage;